/* rd-site.js — behaviour for the Rheo Website Directions build (vanilla JS, no dependencies). */
(function () {
  if (window.__rdSite) { return; }
  window.__rdSite = true;

  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var motion = !reduce;            // laptop + marquee motion
  var reveal = motion && !designMode; // scroll reveal (off inside the theme editor)
  var io = null;
  var mqs = [];
  var raf = 0;
  var mqLast = 0;
  var mqScan = 0;

  /* ---------- scroll reveal ---------- */
  function setupReveal() {
    if (!reveal || !('IntersectionObserver' in window)) { return; }
    if (!io) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            var el = e.target;
            el.style.opacity = '';
            el.style.transform = '';
            io.unobserve(el);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    }
    var i = 0;
    qsa('[data-rd-reveal]:not([data-rd-rv])').forEach(function (el) {
      el.setAttribute('data-rd-rv', '1');
      var r = el.getBoundingClientRect();
      var vis = r.top < window.innerHeight;
      var d = vis ? (i++ * 0.08) : 0;
      el.style.transition = 'opacity .9s cubic-bezier(.2,.7,.2,1) ' + d + 's, transform 1.1s cubic-bezier(.2,.7,.2,1) ' + d + 's, background .3s, color .3s, border-color .3s, box-shadow .3s';
      el.style.transformOrigin = '50% 100%';
      el.style.opacity = '0';
      el.style.transform = 'perspective(1200px) translateY(56px) rotateX(12deg)';
      io.observe(el);
    });
  }

  /* ---------- mobile menu ---------- */
  function setupMenu() {
    var b = qs('[data-rd-burger]');
    var m = qs('[data-rd-mnav]');
    if (!b || !m || b.__rd) { return; }
    b.__rd = 1;
    b.addEventListener('click', function () {
      var o = m.classList.toggle('is-open');
      b.setAttribute('aria-expanded', o ? 'true' : 'false');
    });
    qsa('a', m).forEach(function (a) {
      a.addEventListener('click', function () { m.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false'); });
    });
  }

  /* ---------- auto-scrolling, draggable image reels ---------- */
  function setupMarquees() {
    mqs = mqs.filter(function (m) { return m.el.isConnected; });
    qsa('[data-rd-mq]:not([data-rd-mqi])').forEach(function (el) {
      el.setAttribute('data-rd-mqi', '1');
      var m = { el: el, pos: el.scrollLeft, hover: false, until: 0, drag: null, moved: false, target: null };
      m.hold = function () { m.until = performance.now() + 2500; };
      el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { m.hover = true; } });
      el.addEventListener('pointerleave', function () {
        m.hover = false;
        if (m.drag) { m.drag = null; el.style.cursor = 'grab'; m.hold(); }
      });
      el.addEventListener('wheel', m.hold, { passive: true });
      el.addEventListener('touchstart', function () { m.target = null; m.hold(); }, { passive: true });
      el.addEventListener('touchmove', m.hold, { passive: true });
      el.addEventListener('scroll', function () {
        if (Math.abs(el.scrollLeft - m.pos) > 1.5 && !m.drag) { m.pos = el.scrollLeft; m.target = null; m.hold(); }
      }, { passive: true });
      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') { return; }
        m.drag = { x: e.clientX, pos: m.pos };
        m.moved = false;
        m.target = null;
        el.style.cursor = 'grabbing';
        e.preventDefault();
      });
      window.addEventListener('pointermove', function (e) {
        if (!m.drag) { return; }
        var dx = e.clientX - m.drag.x;
        if (Math.abs(dx) > 4) { m.moved = true; }
        m.pos = m.drag.pos - dx;
      });
      window.addEventListener('pointerup', function () {
        if (m.drag) { m.drag = null; el.style.cursor = 'grab'; m.hold(); }
      });
      el.addEventListener('click', function (e) {
        if (m.moved) { e.stopPropagation(); e.preventDefault(); m.moved = false; }
      }, true);
      mqs.push(m);
    });
  }

  function mqTick(t) {
    var dt = Math.min(50, t - (mqLast || t));
    mqLast = t;
    if (!mqScan || t - mqScan > 500) {
      mqScan = t;
      if (qs('[data-rd-mq]:not([data-rd-mqi])')) { setupMarquees(); }
      if (reveal && qs('[data-rd-reveal]:not([data-rd-rv])')) { setupReveal(); }
    }
    mqs.forEach(function (m) {
      var el = m.el;
      if (!el.isConnected) { return; }
      var half = el.scrollWidth / 2;
      if (half < 10) { return; }
      if (m.target != null) {
        m.pos += (m.target - m.pos) * 0.12;
        if (Math.abs(m.target - m.pos) < 0.5) { m.target = null; }
      } else if (motion && !m.hover && !m.drag && t > m.until) {
        m.pos += dt * 0.045;
      }
      if (m.pos >= half) { m.pos -= half; if (m.target != null) { m.target -= half; } if (m.drag) { m.drag.pos -= half; } }
      if (m.pos < 1) { m.pos += half; if (m.target != null) { m.target += half; } if (m.drag) { m.drag.pos += half; } }
      el.scrollLeft = m.pos;
    });
    window.requestAnimationFrame(mqTick);
  }

  function nudge(btn, dir) {
    var sec = btn.closest('section');
    var el = sec && qs('[data-rd-mq]', sec);
    var m = mqs.filter(function (x) { return x.el === el; })[0];
    if (!m) { return; }
    m.target = (m.target != null ? m.target : m.pos) + dir * el.clientWidth * 0.6;
    m.hold();
  }

  /* ---------- scroll-driven laptop showcase ---------- */
  function tick() {
    var s = qs('[data-rd-show]');
    if (!s) { return; }
    var rig = qs('[data-rd-rig]', s), lid = qs('[data-rd-lid]', s), screenImg = qs('[data-rd-screen]', s);
    var phone = qs('[data-rd-phone]', s), phoneImg = qs('[data-rd-phoneimg]', s), glare = qs('[data-rd-glare]', s);
    var dim = qs('[data-rd-dim]', s), glow = qs('[data-rd-glow]', s), bar = qs('[data-rd-bar]', s);
    var hint = qs('[data-rd-hint]', s);
    /* The pinned frame is only as tall as its content on phones. The section is sized to the frame plus the scroll distance, so when the animation finishes the frame is released immediately and scrolls away naturally with the next section following right behind it (no overlap, no empty black band, no stopping). */
    var stick = qs('.rd-show__stick', s);
    var vh = window.innerHeight;
    var pinH = stick ? stick.offsetHeight : vh;
    s.style.marginBottom = '';
    if (window.innerWidth < 900 && stick) {
      s.style.height = Math.round(pinH + vh * 0.8) + 'px';
    } else {
      s.style.height = '';
    }
    var r = s.getBoundingClientRect();
    var total = r.height - pinH;
    var p = motion ? (total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0) : 1;
    var cl = function (t) { return Math.min(1, Math.max(0, t)); };
    var io3 = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
    var e3 = function (t) { return 1 - Math.pow(1 - t, 3); };
    /* Timing: the laptop starts already tilted-open with the screen visible and finishes opening early; the section is also shorter, so there is less scrolling per unit of movement. The phone arrives exactly when step 03 (Responsive build) becomes active (p >= 0.62). */
    var cam = io3(cl(p / 0.32)), open = io3(cl(p / 0.28)), b = cl((p - 0.3) / 0.6), ph = e3(cl((p - 0.62) / 0.2));
    /* Second half: the laptop keeps gently swivelling and drifting closer while the screen scrolls, so there is always visible 3D movement */
    var dr = cl((p - 0.3) / 0.7), sw = Math.sin(dr * Math.PI);
    if (rig) { rig.style.transform = 'translateY(' + (-60 * (1 - cam)) + '%) rotateX(' + (40 - 40 * cam + 5 * sw) + 'deg) rotateY(' + (-24 + 24 * cam + 12 * sw) + 'deg) rotateZ(' + (-4 + 4 * cam - 1.5 * sw) + 'deg) scale(' + (0.82 + 0.16 * cam + 0.04 * dr) + ')'; }
    if (lid) { lid.style.transform = 'rotateX(' + (-70 + 70 * open) + 'deg)'; }
    if (dim) { dim.style.opacity = String(0.5 * (1 - cl((open - 0.2) / 0.6))); }
    if (hint) { hint.style.opacity = String(1 - cl(p / 0.06)); }
    if (glare) { glare.style.transform = 'translateX(' + (-40 + 80 * p) + '%)'; }
    if (glow) { glow.style.opacity = String(0.2 + 0.8 * open); glow.style.transform = 'translate(-50%,-50%) scale(' + (0.7 + 0.4 * open) + ')'; }
    var scrollImg = function (im) {
      if (!im || !im.parentElement) { return; }
      var d = Math.max(0, im.offsetHeight - im.parentElement.offsetHeight);
      im.style.transform = 'translateY(' + (-d * b) + 'px)';
    };
    scrollImg(screenImg);
    scrollImg(phoneImg);
    if (phone) {
      phone.style.opacity = String(ph);
      phone.style.transform = 'translate(' + ((1 - ph) * 60) + 'px,' + ((1 - ph) * 90 - 10 * sw) + 'px) rotateY(' + (-38 + 26 * ph - 8 * sw) + 'deg) rotateZ(' + ((1 - ph) * 8) + 'deg)';
    }
    if (bar) { bar.style.width = (p * 100) + '%'; }
    var mrows = qsa('[data-rd-step-m]', s);
    var n = Math.max(1, mrows.length || qsa('[data-rd-step-l]', s).length);
    var idx;
    if (n === 3) { idx = p < 0.34 ? 0 : (p < 0.62 ? 1 : 2); } else { idx = Math.min(n - 1, Math.floor(p * n)); }
    qsa('[data-rd-step-l],[data-rd-step-m]', s).forEach(function (el) {
      var i = parseInt(el.getAttribute('data-rd-i'), 10);
      el.style.opacity = i === idx ? '1' : '.35';
    });
    var desc = qs('[data-rd-step-desc]', s);
    if (desc && mrows[idx]) {
      var txt = mrows[idx].getAttribute('data-desc') || '';
      if (desc.textContent !== txt) { desc.textContent = txt; }
    }
  }
  function onScroll() {
    if (!raf) { raf = window.requestAnimationFrame(function () { raf = 0; tick(); }); }
  }

  /* ---------- lightbox ---------- */
  function lbOpen(src) {
    var lb = qs('[data-rd-lb]');
    if (!lb) { return; }
    var im = qs('img', lb);
    im.src = src;
    lb.classList.add('is-open');
  }
  function lbClose() {
    var lb = qs('[data-rd-lb]');
    if (lb) { lb.classList.remove('is-open'); }
  }

  /* ---------- work filter ---------- */
  function applyFilter(f) {
    qsa('[data-rd-group]').forEach(function (g) {
      var grp = g.getAttribute('data-rd-group');
      var hide = (f === 'web' && grp === 'content') || (f === 'content' && grp === 'web');
      g.classList.toggle('is-hidden', hide);
    });
    qsa('[data-rd-filter]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-rd-filter') === f ? 'true' : 'false');
    });
    window.setTimeout(function () { setupReveal(); setupMarquees(); tick(); }, 60);
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var full = t.closest('[data-rd-full]');
    if (full) { lbOpen(full.getAttribute('data-rd-full')); return; }
    if (t.closest('[data-rd-lb]')) { lbClose(); return; }
    var prev = t.closest('[data-rd-mq-prev]');
    if (prev) { nudge(prev, -1); return; }
    var next = t.closest('[data-rd-mq-next]');
    if (next) { nudge(next, 1); return; }
    var f = t.closest('[data-rd-filter]');
    if (f) { applyFilter(f.getAttribute('data-rd-filter')); return; }
    var pt = t.closest('[data-rd-ptype]');
    if (pt) {
      var wrap = pt.parentElement;
      qsa('[data-rd-ptype]', wrap).forEach(function (b) { b.setAttribute('aria-pressed', b === pt ? 'true' : 'false'); });
      var hid = qs('[data-rd-ptype-input]');
      if (hid) { hid.value = pt.getAttribute('data-rd-ptype'); }
      return;
    }
    var enq = t.closest('[data-rd-enquire]');
    if (enq) {
      var sel = qs('[data-rd-service]');
      if (sel) { sel.value = enq.getAttribute('data-rd-enquire'); }
    }
    var top = t.closest('[data-rd-top]');
    if (top) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { lbClose(); } });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) { return; }
    var first = form.querySelector('[data-rd-first]');
    var last = form.querySelector('[data-rd-last]');
    var full = form.querySelector('[data-rd-fullname]');
    if (first && full) { full.value = (first.value + ' ' + (last ? last.value : '')).replace(/\s+/g, ' ').trim(); }
  }, true);

  /* ---------- init ---------- */
  function init() {
    setupMenu();
    setupReveal();
    setupMarquees();
    tick();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  window.addEventListener('load', tick);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { tick(); });
  document.addEventListener('shopify:section:load', init);
  window.requestAnimationFrame(mqTick);
})();
